<template>
  <div class="home">
    <!-- 搜索栏（图1样式 - 更明显） -->
    <div class="search-bar" @click="$router.push('/search')">
      <div class="search-icon-wrapper">
        <van-icon name="search" />
      </div>
      <span class="placeholder">请在此输入搜索关键词</span>
      <div class="arrow-wrapper">
        <van-icon name="arrow" />
      </div>
    </div>

    <!-- 首页仅展示「猜你喜欢」商品列表 -->
    <div class="guess">
      <!--<p class="guess-title" v-html="guessText"></p>-->
      <div class="goods-list">
        <GoodsItem v-for="item in goodsList" :key="item.goods_id" :item="item" />
      </div>
    </div>

    <!-- 底部备案信息 -->
    <div class="footer-record">
      <div class="record-item">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          粤ICP备2025492469号-3
        </a>
      </div>
      <div class="record-item">
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer">
          <img src="//img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png" alt="公安备案图标" />
          粤公网安备44158102000161号
        </a>
      </div>
    </div>

    <!-- 占位，保持底部导航在底部 -->
    <div class="spacer"></div>
  </div>
</template>

<script>
import { getLayoutDataApi } from '@/api/layout'
import GoodsItem from '@/components/GoodsItem.vue'

export default {
  name: 'Home',
  components: {
    GoodsItem
  },
  data () {
    return {
      guessText: '',
      goodsList: []
    }
  },
  created () {
    this.getLayoutData()
  },
  methods: {
    async getLayoutData () {
      const { data: { pageData } } = await getLayoutDataApi()
      if (!pageData || !pageData.items) return
      this.guessText = (pageData.items[3] && pageData.items[3].content && pageData.items[3].content[0] && pageData.items[3].content[0].title) || ''
      this.goodsList = (pageData.items[3] && pageData.items[3].content && pageData.items[3].content[0] && pageData.items[3].content[0].goods_list) || []
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  min-height: 100vh;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
}

// 搜索栏（图1样式 - 更明显）
.search-bar {
  background: #ffffff;
  border-radius: 30px;
  padding: 12px 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e8edf4;
  margin: 16px 16px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .search-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    
    /deep/ .van-icon-search {
      color: #ff6b35;
      font-size: 18px;
    }
  }

  .placeholder {
    flex: 1;
    color: #9aa0a8;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 0.3px;
  }

  .arrow-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    
    /deep/ .van-icon-arrow {
      color: #c0c6ce;
      font-size: 14px;
    }
  }
}

// ============================================================
//  猜你喜欢商品区样式
// ============================================================
.guess {
  margin: 16px 12px 0;
  flex: 1;

  .guess-title {
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a2e;
  }
}

.goods-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

// ============================================================
//  底部备案信息样式
// ============================================================
.footer-record {
  margin-top: 20px;
  padding: 16px 12px 10px;
  text-align: center;
  background: transparent;

  .record-item {
    margin-bottom: 6px;

    a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 12px;
      text-decoration: none;
      transition: color 0.2s;

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        vertical-align: middle;
      }

      &:hover {
        color: #666;
      }

      &:active {
        color: #333;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.spacer {
  flex: 1;
  min-height: 20px;
}
</style>